import React from 'react';
import { getAvatarColor, getInitials } from './chatRows';
import classes from './Chats.module.css';

/** The sender's photo, or their initials on a colour of their own. */
const ChatAvatar = ({ user }) => {
    const name = user?.name || 'Guest';
    if (user?.image) return <img className={classes.avatar} src={user.image} alt={name} />;

    return (
        <span
            className={`${classes.avatar} ${classes.avatarFallback}`}
            style={{ backgroundColor: getAvatarColor(name) }}
            aria-hidden="true"
        >
            {getInitials(name)}
        </span>
    );
};

export default ChatAvatar;
